var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8747 11.4587C17.8747 10.1937 18.9013 9.16699 20.1663 9.16699V8.25033C20.1663 4.58366 19.2497 3.66699 15.583 3.66699H6.41634C2.74967 3.66699 1.83301 4.58366 1.83301 8.25033V8.70866C3.09801 8.70866 4.12467 9.73533 4.12467 11.0003C4.12467 12.2653 3.09801 13.292 1.83301 13.292V13.7503C1.83301 17.417 2.74967 18.3337 6.41634 18.3337H15.583C19.2497 18.3337 20.1663 17.417 20.1663 13.7503C18.9013 13.7503 17.8747 12.7237 17.8747 11.4587Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 3.66699L9.16699 18.3337",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.58 4.58"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.e5a5445314668c8e3e54d6075fa0bdad.svg";
export { ForwardRef as ReactComponent };